import { Headline, Paragraph } from 'View/Common';
import { HoverImageLink } from 'View/Component';
import { FC } from 'react';
import { CooperationStyle } from './HealthCooperations.style';
import { useGetInsuranceCompaniesQuery } from 'api/graphql';

type THealthCooperationsProps = {
  id: string;
};

export const HealthCooperations: FC<THealthCooperationsProps> = ({ id }) => {
  const { data } = useGetInsuranceCompaniesQuery({
    variables: {
      isCooperationPartner: true,
    },
  });
  const { insuranceCompanies } = data || {};

  const cooperation = insuranceCompanies?.[0];

  if (!cooperation || !cooperation.cooperationLogo || !cooperation.cooperationLogoHover) {
    return null;
  }

  return (
    <CooperationStyle id={id} className="text-center" type="full-width">
      <Headline level={2}>Starte ohne Vorauszahlung</Headline>
      <Paragraph className="subline">bei diesen Krankenkassen</Paragraph>
      <div className="slider-wrapper">
        <HoverImageLink
          image={cooperation.cooperationLogo}
          hoverImage={cooperation.cooperationLogoHover}
          href={cooperation.cooperationUrl}
          className="logo logo--single"
        />
      </div>
      <Paragraph className="info-text">
        Wenn du bei einer unserer Kooperations-Krankenkassen versichert bist, kannst du den Präventionskurs sogar direkt starten, ganz ohne
        Vorauszahlung. Einfach auf das Logo deiner Krankenkasse klicken und mehr erfahren.
      </Paragraph>
    </CooperationStyle>
  );
};
